import purify from "dompurify";
import { useTranslation } from "pro-features/components/WithTranslation/src/I18n";

import { Button, Modal } from "@similarweb/ui-components";
import { Text } from "@similarweb/ui-components/foundations";

import {
    DUNNINGS_POP_UP_CTA_LOCATION,
    DUNNINGS_UPDATE_BILLING_EVENT_SUB_SUB_NAME,
    NT_DUNNINGS_EVENT_NAME,
} from "app/components/Dunnings/dunningsConstants";
import {
    DunningsModalContent,
    DunningsModalFooter,
    DunningsTextContactUsButton,
    StyledTitle,
} from "app/components/Dunnings/DunningsModal/DunningsModalStyled";
import { DunningsLinkText } from "app/components/Dunnings/DunningsStyled";
import { useDunningsModal } from "app/components/Dunnings/useDunningsModal";
import { useDunnings } from "app/components/hooks/useDunnings";
import { AssetsService } from "app/services/AssetsService";

export const DunningsModal = () => {
    const { onContactUsClicked } = useDunnings();
    const { isOpen, onCloseClicked, onDunningsButtonClicked } = useDunningsModal({
        eventName: NT_DUNNINGS_EVENT_NAME,
        eventSubSubName: DUNNINGS_UPDATE_BILLING_EVENT_SUB_SUB_NAME,
    });
    const translate = useTranslation();

    const onClick = () => onDunningsButtonClicked("billing");
    const onContactUsButtonClicked = () =>
        onContactUsClicked(`${NT_DUNNINGS_EVENT_NAME}/${DUNNINGS_POP_UP_CTA_LOCATION}`);

    return (
        <Modal
            isOpen={isOpen}
            data-automation="dunnings-modal"
        >
            <StyledTitle>{translate("dunnings.modal.title")}</StyledTitle>

            <DunningsModalContent>
                <div>
                    <Text
                        fontVariant="body2"
                        dangerouslySetInnerHTML={{
                            // eslint-disable-next-line @typescript-eslint/naming-convention
                            __html: purify.sanitize(translate("dunnings.modal.text")),
                        }}
                    />{" "}
                    <DunningsTextContactUsButton onClick={onContactUsButtonClicked}>
                        <DunningsLinkText
                            fontVariant="body2"
                            dangerouslySetInnerHTML={{
                                // eslint-disable-next-line @typescript-eslint/naming-convention
                                __html: purify.sanitize(translate("dunnings.modal.contact_us")),
                            }}
                        />
                    </DunningsTextContactUsButton>
                    {"."}
                </div>

                <img
                    alt={translate("dunnings.modal.image_alt")}
                    src={AssetsService.assetUrl("images/dunnings/payment_denied.svg")}
                />
            </DunningsModalContent>

            <DunningsModalFooter>
                <Button
                    type="flat"
                    onClick={onCloseClicked}
                >
                    {translate("dunnings.modal.dismiss_modal")}
                </Button>

                <Button
                    type="primary"
                    onClick={onClick}
                >
                    {translate("dunnings.modal.update_billing")}
                </Button>
            </DunningsModalFooter>
        </Modal>
    );
};
